import { defaults } from 'lodash-es';
import template from './form.html';
import { ADDRESS_FIELDS, ADDRESS_ERRORS, ALL_STATES } from '../constants';
import './form.global.css';
import '@updater-components/radio-group';

const MODEL_OPTIONS = {
  updateOn: 'default blur',
  debounce: {
    default: 700,
    blur: 0,
  },
};

const buildGetFieldName = name => field => `${field}_${name}`;

class AddressFormController {
  modelOptions = MODEL_OPTIONS;
  states = ALL_STATES;
  fields = {};

  $onInit() {
    defaults(this, {
      showOwnership: false,
    });

    const getFieldName = buildGetFieldName(this.name);
    this.streetName = getFieldName('street');
    this.aptName = getFieldName('apt');
    this.cityName = getFieldName('city');
    this.stateName = getFieldName('state');
    this.zipName = getFieldName('zip');
    this.ownershipName = getFieldName('ownership');
  }

  $onChanges(changes) {
    const { model } = changes;
    if (model) {
      Object.assign(this.fields, model.currentValue);
    }
  }

  isRequired(field) {
    return (this.requiredFields || []).includes(field);
  }

  onFieldChange() {
    this.change({ $value: this.fields });
  }

  onRadioChange(e) {
    this.fields.ownership = e.target.value;
    this.change({ $value: this.fields });
  }

  get isFormSubmitted() {
    return this.formCtrl.$submitted;
  }
}

export const AddressFormComponent = {
  require: {
    formCtrl: '^^?form',
    modelCtrl: 'ngModel',
  },
  bindings: {
    model: '<ngModel',
    name: '@',
    label: '@',
    change: '&',
    requiredFields: '<?',
  },
  template,
  controller: AddressFormController,
};
